"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;
var _styles = require("@material-ui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _Fonts = require("../constants/Fonts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Typography = function Typography(props) {
  var category = props.category,
    variant = props.variant,
    children = props.children,
    className = props.className,
    style = props.style,
    htmlColor = props.htmlColor,
    dangerouslySetInnerHTML = props.dangerouslySetInnerHTML,
    dir = props.dir,
    onClick = props.onClick;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement("span", {
    onClick: onClick,
    dir: dir,
    className: (0, _clsx.default)(className),
    style: _objectSpread(_objectSpread({}, _Fonts.Fonts[category !== null && category !== void 0 ? category : "Default"][variant]), {}, {
      fontFamily: theme.typography.fontFamily,
      color: htmlColor
    }, style),
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }, children);
};
exports.Typography = Typography;